"use strict";

var _interopRequireDefault = require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.presets = exports.Presets = void 0;
var _defineProperty2 = _interopRequireDefault(require("/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty.js"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _dateFns = require("date-fns");
var _elements = require("../../../../elements");
var _presetsModule = _interopRequireDefault(require("./presets.module.scss"));
var _enGB = _interopRequireDefault(require("date-fns/locale/en-GB"));
var _useTranslation2 = require("../../../../hooks/useTranslation/useTranslation");
var presets = [{
  text: 'date.presets.thisWeek',
  start: (0, _dateFns.startOfWeek)(new Date(), {
    locale: _enGB.default
  }),
  end: (0, _dateFns.startOfDay)((0, _dateFns.endOfWeek)(new Date(), {
    locale: _enGB.default
  }))
}, {
  text: 'date.presets.lastWeek',
  start: (0, _dateFns.startOfWeek)((0, _dateFns.subWeeks)(new Date(), 1), {
    locale: _enGB.default
  }),
  end: (0, _dateFns.startOfDay)((0, _dateFns.endOfWeek)((0, _dateFns.subWeeks)(new Date(), 1), {
    locale: _enGB.default
  }))
}, {
  text: 'date.presets.thisMonth',
  start: (0, _dateFns.startOfMonth)(new Date()),
  end: (0, _dateFns.startOfDay)((0, _dateFns.endOfMonth)(new Date()))
}, {
  text: 'date.presets.lastMonth',
  start: (0, _dateFns.startOfMonth)((0, _dateFns.subMonths)(new Date(), 1)),
  end: (0, _dateFns.startOfDay)((0, _dateFns.endOfMonth)((0, _dateFns.subMonths)(new Date(), 1)))
}];
exports.presets = presets;
var Presets = function Presets(_ref) {
  var startDate = _ref.startDate,
    endDate = _ref.endDate,
    onDateChange = _ref.onDateChange;
  var _useTranslation = (0, _useTranslation2.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _presetsModule.default['presets']
  }, presets.map(function (_ref2) {
    var text = _ref2.text,
      start = _ref2.start,
      end = _ref2.end;
    var isSelected = (0, _dateFns.isSameDay)(startDate, start) && (0, _dateFns.isSameDay)(endDate, end);
    return /*#__PURE__*/_react.default.createElement(_elements.NeutralButton, {
      key: text,
      small: true,
      className: (0, _classnames.default)(_presetsModule.default['presets__button'], (0, _defineProperty2.default)({}, _presetsModule.default['presets__button--active'], isSelected)),
      onClick: function onClick() {
        onDateChange({
          startDate: start,
          endDate: end
        });
      },
      tabIndex: -1
    }, t(text));
  }));
};
exports.Presets = Presets;